/*!
 * Habtium: the Habbo universe on your hand.
 *
 * @link https://habtium.es/about
 * @copyright 2006 - 2016 Habtium
 */

/*!
 * Comments object.
 *
 * @author Rodolfo Thiede <rodolfo@habtium.com>
 * @author Víctor Díaz <victor@axiomer.com>
 * @author Fran Torregrosa <fran@axiomer.com>
 */
var Comments = {
    lock: false,
    init: function (item, id) {
        function renderAvatar({
            avatar,
            decoration = null,
            username = null,
            size = 72,
        }) {
            const content = `
        <div
            class="avatar-decoration"
            style="--avatar-size: ${size}px;"
        >
            <img
                class="avatar-decoration__avatar"
                src="${avatar}"
                alt=""
            />

            ${
                decoration
                    ? `
                <img
                    class="avatar-decoration__frame"
                    src="${decoration}"
                    alt=""
                />
            `
                    : ""
            }
        </div>
    `;

            if (!username) {
                return content;
            }

            return `
        <a href="/${username}">
            ${content}
        </a>
    `;
        }

        function putComment(where, c) {
            const achievement = c.achievement
                ? `
            <div
                style="
                    background: url(/images/hexagon_grey.png), url(${c.achievement});
                    background-size: 50px 50px, 50px 50px;
                    width: 50px;
                    height: 50px;
                    margin: 10px;
                "
            ></div>
        `
                : "";

            const sticker = c.sticker
                ? `
            <div
                style="
                    background: url(/images/stickers_container.png), url(${c.sticker});
                    background-size: 50px 50px, 50px 50px;
                    width: 50px;
                    height: 50px;
                    margin: 10px;
                "
            ></div>
        `
                : "";

            const canDelete =
                (!c.approved && c.account == App.account_id) ||
                (item === "profile" && id == App.account_id);

            const deleteButton = canDelete
                ? `
            <button
                class="button red"
                onclick="Comments.delete('${c.id}')"
            >
                <span class="glyphicons glyphicons-bin"></span>
            </button>
        `
                : "";

            const avatarDecoration = c.avatarDecoration
                ? `
            <img
                src="${c.avatarDecoration}"
                style="
                    position: absolute;
                    width: 60px;
                    height: 60px;
                    inset: 0;
                    object-fit: contain;
                    z-index: 2;
                    pointer-events: none;
                "
            />
        `
                : "";

            const avatar = renderAvatar({
                avatar: c.avatar,
                decoration: c.avatarDecoration,
                username: c.username,
                size: 60,
            });

            const boxSize =
                item === "profile"
                    ? "medium"
                    : item === "story"
                      ? "biggest"
                      : "big";

            $("#_content")[where](`
        <div
            data-id="${c.id}"
            id="comment-${c.id}"
            class="comment-v2 box box-${boxSize}"
            style="
                box-shadow: 0 0 2px rgba(0,0,0,.05);
                float: left;
                border-radius: 5px;
                flex-direction: column;
                margin-left: 6px;
                margin-top: 6px;
            "
        >
            <div
                style="
                    align-items: center;
                    display: flex;
                    justify-content: space-between;
                    padding: 5px;
                    background-color: #F5F5F5;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                "
            >
                <div
                    style="
                        display: flex;
                        gap: 10px;
                        align-items: center;
                    "
                >
                    ${avatar}

                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                        "
                    >
                        <div
                            style="
                                display: flex;
                                align-items: center;
                                gap: 5px;
                            "
                        >
                            <h1>
                                <a
                                    href="/${c.username}"
                                    style="color: black"
                                >
                                    ${c.nick}
                                </a>
                            </h1>

                            <span
                                style="
                                    width: 10px;
                                    height: 10px;
                                    background-color: ${c.online ? "green" : "red"};
                                    border-radius: 50%;
                                "
                            ></span>
                        </div>

                        <small
                            style="
                                font-size: 10px;
                                color: #737373;
                            "
                        >
                            ${Time.getHTML(c.time)}
                        </small>
                    </div>
                </div>

                <div
                    style="
                        display: flex;
                        align-items: center;
                        margin-right: 5px;
                    "
                >
                    ${deleteButton}
                    ${achievement}
                    ${sticker}
                </div>
            </div>

            <div
                style="
                    background-color: white;
                    border-bottom-right-radius: 5px;
                    border-bottom-left-radius: 5px;
                    padding: 10px;
                "
            >
                ${c.content}
            </div>
        </div>
    `);
        }

        function _putComment(where, c) {
            Language.get([
                "achievements." + c.achievement + ".name",
                "achievements." + c.achievement + ".description",
            ]).then(function (strings) {
                $("#_content")[where](
                    '<a name="' +
                        c.id +
                        '"></a><div id="comment-' +
                        c.id +
                        '" class="box box-' +
                        (item == "profile"
                            ? "medium"
                            : item == "story"
                              ? "biggest"
                              : "big") +
                        ' item-top comment" data-id="' +
                        c.id +
                        '" style="overflow:visible;"><div class="account-box' +
                        (c.online ? " online" : " offline") +
                        '"><div class="avatar" style="background-image:url(' +
                        c.avatar +
                        ');"><a href="/' +
                        c.username +
                        '"></a></div>' +
                        (c.achievement != 0
                            ? '<div class="achievement" rel="tooltip" data-name="' +
                              strings[0] +
                              '" data-description="' +
                              strings[0] +
                              '" style="background-image:url(/images/hexagon_grey.png), url(' +
                              c.achievement +
                              ');"><a href="/' +
                              c.username +
                              "/achievements#" +
                              c.achievement +
                              '"></a></div>'
                            : "") +
                        "" +
                        ((!c.approved && c.account == App.account_id) ||
                        (item == "profile" && id == App.account_id)
                            ? '<div class="button grey" onclick="Comments.delete(' +
                              c.id +
                              ');"><span class="glyphicons glyphicons-bin"></span></div>'
                            : "") +
                        '<div class="body"><span>' +
                        '<h1><a href="/' +
                        c.username +
                        '">' +
                        c.nick +
                        "</a></h1>" +
                        "<h2>" +
                        Time.getHTML(c.time) +
                        '</h2></span></div></div><div class="body text">' +
                        c.content +
                        "</div></div>",
                );
            });
        }

        Comments.lock = true;
        Api.get("/comments", { item: item, id: id }, function (r) {
            if (!r.error) {
                for (var i = 0; i < r.data.length; i++) {
                    putComment("append", r.data[i]);
                }
            }
            Comments.lock = false;
        });

        $("#comments_form").submit(function (e) {
            e.preventDefault();
            if (!Comments.lock) {
                Comments.lock = true;
                Api.post(
                    "/comments",
                    {
                        item: item,
                        id: id,
                        content: $("#comment_content")
                            .attr("disabled", true)
                            .val(),
                    },
                    function (r) {
                        if (!r.error) {
                            $("#comment_content").val("");

                            Language.get([
                                "achievements." + r.achievement + ".name",
                                "achievements." +
                                    r.achievement +
                                    ".description",
                            ]).then(function (strings) {
                                putComment("prepend", r);
                                //							$('#_content').prepend('<a name="' + r.id + '"></a><div id="comment-' + r.id + '" class="box box-' + (item == 'profile' ? 'medium' : (item=='story') ? 'biggest' : 'big') + ' item-top animated bounceInDown" style="overflow:visible;"><div class="account-box online"><div class="avatar" style="background-image:url(' + r.avatar + ');"><a href="/' + r.username + '"></a></div><div class="achievement" rel="tooltip" data-name="' + strings[0] + '" data-description="' + strings[1] + '" style="background-image:url(/images/hexagon_grey.png), url(//cdn.habtium.com/achievements/' + r.achievement + '.png);"><a href="/' + r.username + '/achievements#' + r.achievement + '"></a></div><div class="button grey" onclick="Comments.delete(' + r.id + ');"><span class="halflings halflings-trash"></span></div><div class="body"><span>' + (r.name != r.nick ? '<h1><a href="/' + r.username + '">' + r.name + '</h1></a> <i>' + r.nick + '</i>' : '<h1><a href="/' + r.username + '">' + r.nick + '</a></h1>') + '<h2>' + Time.getHTML(r.time) + '</h2></span></div></div><div class="body text">' + r.content + '</div>');
                            });
                        } else {
                            switch (r.error.identifier) {
                                case "internal_error":
                                    Alert.push([
                                        {
                                            type: "danger",
                                            text: "¡Hey! Hubo un error al intentar enviar tu comentario. Vuelve a intentarlo.",
                                            icon: "triangle-alert",
                                        },
                                    ]);
                                    break;
                                case "request_verify_2_error":
                                    Alert.push([
                                        {
                                            type: "danger",
                                            text: "¡Hey! Ya publicaste este comentario antes.",
                                            icon: "triangle-alert",
                                        },
                                    ]);
                                    break;
                                case "request_verify_1_error":
                                    Alert.push([
                                        {
                                            type: "danger",
                                            text: "¡Hey! Has publicado un comentario hace menos de 10 segundos.",
                                            icon: "triangle-alert",
                                        },
                                    ]);
                                    break;
                                case "request_parameter_too_long/content":
                                    Alert.push([
                                        {
                                            type: "danger",
                                            text: "¡Hey! El contenido de tu comentario es demasiado largo. La máxima longitud de un comentario es de 300 carácteres.",
                                            icon: "triangle-alert",
                                        },
                                    ]);
                                    break;
                                case "request_parameter_empty/content":
                                    Alert.push([
                                        {
                                            type: "danger",
                                            text: "¡Hey! Parece que has intentado enviar un comentario vacío.",
                                            icon: "triangle-alert",
                                        },
                                    ]);
                                    break;
                                case "comments_service_disabled":
                                    Alert.push([
                                        {
                                            type: "danger",
                                            text: "¡Hemos tenido que restringir la creación de comentarios momentáneamente! Regresa pronto.",
                                            icon: "triangle-alert",
                                        },
                                    ]);
                                    break;
                            }
                        }
                        $("#comment_content").attr("disabled", false);
                        Comments.lock = false;
                    },
                );
            }
        });

        $(window).scroll(function () {
            if (
                $(window).height() + $(window).scrollTop() ==
                $(document).height()
            ) {
                if (!Comments.lock) {
                    Comments.lock = true;
                    Api.get(
                        "/comments",
                        {
                            item: item,
                            id: id,
                            last: $(".comment-v2:last").data("id"),
                        },
                        function (r) {
                            if (!r.error) {
                                for (var i = 0; i < r.data.length; i++) {
                                    putComment("append", r.data[i]);
                                }
                            }
                            Comments.lock = false;
                        },
                    );
                }
            }
        });
    },

    delete: function (comment_id) {
        Api.delete("/comments/" + comment_id, {}, function (r) {
            $("#comment-" + comment_id)
                .fadeOut()
                .remove();
        });
    },
};
